import { render, staticRenderFns } from "./FooterBourdain.vue?vue&type=template&id=27180dbc&lang=pug&"
import script from "./FooterBourdain.vue?vue&type=script&lang=js&"
export * from "./FooterBourdain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27180dbc')) {
      api.createRecord('27180dbc', component.options)
    } else {
      api.reload('27180dbc', component.options)
    }
    module.hot.accept("./FooterBourdain.vue?vue&type=template&id=27180dbc&lang=pug&", function () {
      api.rerender('27180dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/footer/FooterBourdain.vue"
export default component.exports